import { render, staticRenderFns } from "./Bath.vue?vue&type=template&id=958b60bc&scoped=true"
import script from "./Bath.vue?vue&type=script&lang=js"
export * from "./Bath.vue?vue&type=script&lang=js"
import style0 from "./Bath.vue?vue&type=style&index=0&id=958b60bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958b60bc",
  null
  
)

export default component.exports